import React from "react";
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import BannerImage from "../../../assets/image/image-page-banner.webp";
import Story from "../../../components/sections/front/Vpeters/Story";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import TextWithImageBlock from "../../../components/sections/front/Common/TextWithImageBlock";

import InspiresImage from "../../../assets/image/image-event-01.webp";
import ImpactImage from "../../../assets/image/image-event-03.webp";
import Publications from "../../../components/sections/front/Vpeters/Publications";
import { useBanner } from "../../../providers/BannerProviders";
import { Helmet } from "react-helmet-async";

const Vpeters = () => {
  const { data } = useBanner();
  const vpetersBanner = data?.data?.find(
    (item) => item?.bannerType === "v'Peters"
  );

  const InspiresData = {
    ...vpetersBanner?.details?.inspire,
    image: vpetersBanner?.details?.inspire?.image?.url,
  };

  const ImpactData = {
    ...vpetersBanner?.details?.impact,
    image: vpetersBanner?.details?.impact?.image?.url,
  };

  return (
    <>
      {vpetersBanner && (
        <Helmet>
          <title>{vpetersBanner.seoTitle}</title>
          <meta
            name="description"
            property="og:description"
            content={vpetersBanner.seoDescription}
          />
          <meta
            name="keywords"
            property="og:keywords"
            content={vpetersBanner.seoKeyword}
          />
          <meta
            name="author"
            property="og:author"
            content={vpetersBanner.seoAuthor}
          />
          <meta
            property="og:image"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:secure_url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
        </Helmet>
      )}
      <PageBanner
        title={vpetersBanner?.title}
        image={vpetersBanner?.image?.url}
      />
      <Story />
      <TextWithImageBlock
        data={InspiresData}
        imageFirst={false}
        bgColor={"bg-chestnut-rose"}
      />
      <TextWithImageBlock
        data={ImpactData}
        imageFirst={true}
        bgColor={"bg-blue-zodiac"}
      />
      <Publications />
      <OurPartners />
    </>
  );
};

export default Vpeters;
